import { Component, type ReactNode } from 'react';
import { AlertTriangle } from '@/utils/icons';
import { Button } from '@/components/ui/button';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="dls-flex dls-flex-col dls-items-center dls-justify-center dls-min-h-[400px] dls-p-8">
          <AlertTriangle className="dls-h-12 dls-w-12 dls-text-status-offline dls-mb-4" />
          <h2 className="dls-text-xl dls-font-semibold dls-mb-2">Something went wrong</h2>
          <p className="dls-text-muted-foreground dls-mb-4">
            {this.state.error?.message || 'An unexpected error occurred'}
          </p>
          <Button onClick={() => window.location.reload()}>Reload page</Button>
        </div>
      );
    }

    return this.props.children;
  }
}
